import React from "react";
import { Select } from "../select/Select.js";
function SelectFilter({ value, onChange, selectMode = "client", ...props }) {
  function handleSubmit(value2) {
    let result;
    if (props?.multiple) {
      result = value2?.length ? value2 : "";
    } else {
      result = value2 ? value2[0] : "";
    }
    onChange(result);
  }
  return /* @__PURE__ */ React.createElement(Select, { ...props, value, onSubmit: handleSubmit, showResetButton: true, mode: selectMode });
}
export {
  SelectFilter
};
//# sourceMappingURL=SelectFilter.js.map
